import React from 'react';
import styles from './WorkExperience.module.css';

interface WorkExperienceItem {
  title: string;
  company: string;
  period: string;
  description: string[];
  technologies: string[];
}

const WorkExperience: React.FC = () => {
  const experiences: WorkExperienceItem[] = [
    {
      title: "Software Engineer",
      company: "Rakuten Group, Inc.",
      period: "April 2023 - Present",
      description: [
        "Reduced after-hours issue handling time by 30% through automated alerting solutions",
        "Improved CI/CD pipeline by adding CI, SonarQube and automated testing, improving application quality",
        "Migrated self-hosted applications to in-house cloud infrastructure, improving scalability",
        "Introduced agile practices, improving development cycle times"
      ],
      technologies: ["Java", "Spring", "CI/CD", "Oracle DB", "Docker, Kubernetes"]
    },
    {
      title: "Software Engineer",
      company: "menu, Inc.",
      period: "July 2022 - March 2023",
      description: [
        "Improved report processing speeds by 80% through SQL optimization and backend refactoring",
        "Delivered new user-facing features and resolved critical bugs across systems",
        "Enhanced onboarding by translating key documentation from Japanese to English"
      ],
      technologies: ["MySQL", "PHP", "Twig", "Github Actions"]
    },
    {
      title: "Fullstack developer",
      company: "Rakuten Group, Inc.",
      period: "December 2017 - June 2022",
      description: [
        "Automated customer service calls using Twilio Studio, improving redelivery processes",
        "Boosted mobile app performance by 50% through SQL optimization and Firebase analytics",
        "Enhanced CI/CD workflows with Jenkins, Docker, and Kubernetes for automation",
        "Developed an Android scanning app, reducing parcel sorting time by over 100%"
      ],
      technologies: ["Android", "Java", "Kotlin", "Spring", "CI/CD", "Oracle DB", "Docker, Kubernetes"]
    },
    {
      title: "Mobile developer",
      company: "i-hearts",
      period: "October 2016 - December 2017",
      description: [
        "Expanded user base by creating a web version of the native mobile app using React",
        "Designed responsive web applications compatible across devices, enhancing accessibility",
        "Localized mobile apps, increasing App Store and Play Store visibility by 20%"
      ],
      technologies: ["JavaScript", "Swift", "React", "Android/iOS"]
    },
  ];

  return (
    <div className={styles.workExperience}>
      <h2>Work Experience</h2>
      <ul className={styles.timeline}>
        {experiences.map((exp, index) => (
          <li key={index}>
            <div className={styles.timelineItem}>
              <div className={styles.timelineHeader}>
                <h3>{exp.title}</h3>
                <span className={styles.period}>{exp.period}</span>
              </div>
              <p className={styles.company}>{exp.company}</p>
              <ul className={styles.description}>
                {exp.description.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
              <div className={styles.technologies}>
                {exp.technologies.map((tech, i) => (
                  <span key={i} className={styles.tag}>{tech}</span>
                ))}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WorkExperience;